/* eslint-disable better-mutation/no-mutation */

import { getUnsoldItem } from './items';
import { logger } from 'packages/logger';
import { findKeysByItemId } from '../../helpers/commands-helper.js';
import { isServer } from 'tradera/utils/nextjs';

if (isServer) {
    // Do not remove this without also removing the disable of eslint better-mutation/no-mutation at top of file.
    throw new Error(
        'This implementation is not compatible with SSR as global properties are shared between server instances'
    );
}

const updateUnsoldLabelsAndActions = (item, listViewType) => {
    if (listViewType === undefined) {
        try {
            throw (
                'updateUnsoldLabelsAndActions: listViewType === undefined, ' +
                item
            );
        } catch (e) {
            logger(e);
        }
    }
    return getUnsoldItem(item, listViewType);
};

const setUnsoldItemHiddenState =
    (flag, listViewType) => (items, memberId) => (key) => {
        const item = items[key];
        if (!item) {
            try {
                throw `setUnsoldItemHiddenState failed. tried to find key ${key} in ${JSON.stringify(
                    items
                )}`;
            } catch (err) {
                logger(err);
            }
            return [];
        }

        if (!item.hiddenByMember?.includes(memberId)) {
            item.removeFromList = true;
        }
        return updateUnsoldLabelsAndActions(item, listViewType, memberId);
    };

const setItemsHasRestartedChild = (flag, listViewType) => (items) => (key) => {
    const item = items[key];
    if (!item) {
        try {
            throw `setItemHasRestartedChild failed. tried to find key ${key} in ${JSON.stringify(
                items
            )}`;
        } catch (err) {
            logger(err);
        }
        return [];
    }

    item.listing.restart.hasRestartedChild = flag;
    return updateUnsoldLabelsAndActions(item, listViewType);
};

export const markItemAsHiddenReducer = (state, action) => {
    const updatedItems = { ...state.itemsByID };
    const updateChangedItems = setUnsoldItemHiddenState(
        true,
        action.payload.listViewType
    )(updatedItems, state.currentMemberId);
    const findUpdatedKeysByItemId = findKeysByItemId(updatedItems);
    action.payload.ids.map(findUpdatedKeysByItemId).map(updateChangedItems);
    return updatedItems;
};

export const markItemAsShownReducer = (state, action) => {
    const updatedItems = { ...state.itemsByID };
    const updateChangedItems = setUnsoldItemHiddenState(
        false,
        action.payload.listViewType
    )(updatedItems);
    const findUpdatedKeysByItemId = findKeysByItemId(updatedItems);
    action.payload.ids.map(findUpdatedKeysByItemId).map(updateChangedItems);
    return updatedItems;
};

export const setRestartedReducer = (state, action) => {
    const stateItems = { ...state.itemsByID };
    const updateChangedItems = setItemsHasRestartedChild(
        true,
        action.payload.listViewType
    )(stateItems);
    const findUpdatedKeysByItemId = findKeysByItemId(stateItems);
    const updatedItems = action.payload.itemIds
        .map(findUpdatedKeysByItemId)
        .map(updateChangedItems);
    updatedItems.forEach((updatedItem) => {
        stateItems[updatedItem.key] = updatedItem;
    });
    return stateItems;
};
